<form [formGroup]="form" class="px-3">
  <div class="row flex-between-center">
    <div class="col-1">
      <app-validated-dropdown
        [inputFormControl]="form.controls.titleCode"
        inputFormControlName="title"
        label="general.nameTitle"
        [leaveSpaceForValidation]="true"
        [loading]="!store.allLoaded() || store.nameTitlesEntities().length === 0"
        [optionsStamp]="store.nameTitlesEntities().length"
      >
        <option
          *ngFor="let nameTitle of store.nameTitlesEntities()"
          [value]="nameTitle.code"
        >
          {{ nameTitle.localized | getLocalized }}
        </option>
      </app-validated-dropdown>
    </div>
    <div class="col">
      <app-validated-input
        [inputFormControl]="form.controls.lastName"
        inputFormControlName="lastName"
        label="general.lastName"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>

    <div class="col">
      <app-validated-input
        [inputFormControl]="form.controls.middleName"
        inputFormControlName="middleName"
        label="general.middleName"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>

    <div class="col">
      <app-validated-input
        [inputFormControl]="form.controls.firstName"
        inputFormControlName="firstName"
        label="general.firstName"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      <app-validated-input
        [inputFormControl]="form.controls.phoneNumber"
        inputFormControlName="phoneNumber"
        label="general.phone"
        [leaveSpaceForValidation]="true"
      ></app-validated-input>
    </div>
  </div>
</form>
